import { SessionStats } from 'src/replicant/stats/stats.ruleset';
import { sessionStats } from './stats.modifiers';

/**
 * Get current session stats of user activity
 */
export function getSession(id: SessionStats, initial: number): number {
  return sessionStats[id] ?? initial;
}
